import { httpGet, httpPost } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getOauthCode(clientID, email) {
    let apiUrl = `${this.apiEndpoint}/api/oauth/code?clientID=${clientID}&email=${email}`;
    return httpGet(apiUrl);
  }
}
